import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText, formatBytes } from "@/lib/api";
import FileDropzone from "@/components/admin/FileDropzone";
import FilesTable from "@/components/admin/FilesTable";

export default function FilesManager() {
  const [files, setFiles] = useState([]);
  const [folder, setFolder] = useState("");
  const [uploading, setUploading] = useState(0);

  const load = useCallback(() => api.get("/files").then((r) => setFiles(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const upload = async (list) => {
    if (!list?.length) return;
    const fd = new FormData();
    [...list].forEach((f) => fd.append("files", f));
    fd.append("folder", folder);
    try {
      const { data } = await api.post("/files", fd, { onUploadProgress: (e) => setUploading(Math.round((e.loaded / (e.total || 1)) * 100)) });
      toast.success(`Wgrano plików: ${data.length}`);
      load();
    } catch (e) { toast.error(errorText(e)); } finally { setUploading(0); }
  };

  const remove = async (path) => { await api.delete("/files", { params: { path } }); toast.success("Usunięto plik"); load(); };
  const total = files.reduce((s, f) => s + f.size, 0);

  return (
    <div className="space-y-8">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-display text-2xl text-amber-100">Pliki patcha</h2>
          <p className="text-sm text-slate-500 mt-1">Ścieżki względem folderu klienta gry. Manifest i sumy SHA-256 generują się automatycznie.</p>
        </div>
        <div className="text-right">
          <div className="font-mono text-2xl text-amber-300" data-testid="files-total-size">{formatBytes(total)}</div>
          <div className="text-xs text-slate-500" data-testid="files-count">{files.length} plików</div>
        </div>
      </div>
      <div className="grid md:grid-cols-[260px_1fr] gap-4">
        <div>
          <label className="text-xs tracking-widest text-slate-500">Folder docelowy</label>
          <input value={folder} onChange={(e) => setFolder(e.target.value)} placeholder="np. pack" data-testid="files-folder-input"
            className="mt-2 w-full bg-black/40 border border-white/10 rounded px-3 py-2 text-sm font-mono focus:border-amber-500/60 outline-none transition-colors" />
          <p className="text-[11px] text-slate-600 mt-2">Puste = główny folder (np. metin2client.exe).</p>
        </div>
        <FileDropzone uploading={uploading} onFiles={upload} />
      </div>
      <FilesTable files={files} onRemove={remove} />
    </div>
  );
}
